import template from './setCreditCheckModal.html';
import controller from './setCreditCheckModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    selectedContact: '<',
    clientsList: '<',
  },
};
